export default {
  Basic: 1,
  OneThousand: 2,
  Million: 3,
  OneBillion: 4,
};
